import React from 'react'
import { parsePartOfSpeech, PosCategory } from 'lib/partOfSpeech'

type Props = {
   // Raw part-of-speech string from the DB, e.g. "StativeVerb ; Adjective" or a
   // "·"-joined summary across senses. May contain camelCase compound tokens.
   value: string | null | undefined
   className?: string
}

// One coloured chip per part of speech. Colour is keyed on the POS category so
// the same part of speech is always the same colour (see lib/partOfSpeech).
const CATEGORY_HUE: Record<PosCategory, string> = {
   noun: '#2f74d0',
   verb: '#1f9488',
   adjective: '#7358cf',
   adverb: '#c65d2e',
   pronoun: '#cf4d94',
   function: '#5b6b82',
   interjection: '#d64550',
   numeral: '#0e8fa8',
   other: '#6b7280',
}

const PartOfSpeechChips = (props: Props) => {
   const tokens = parsePartOfSpeech(props.value)
   if (tokens.length === 0) {
      return null
   }

   return (
      <div
         className={`inline-flex flex-wrap gap-[6px] items-center ${props.className ?? ''}`.trim()}
      >
         {tokens.map((token) => (
            <span
               key={token.label}
               className="inline-flex items-center text-[12px] font-semibold not-italic leading-none tracking-[0.01em] px-[9px] py-[4px] rounded-full whitespace-nowrap bg-[color-mix(in_srgb,var(--pos-hue)_13%,var(--color-white))] text-[color-mix(in_srgb,var(--pos-hue)_68%,var(--color-bodyBlack))] border border-[color-mix(in_srgb,var(--pos-hue)_26%,transparent)]"
               style={{ '--pos-hue': CATEGORY_HUE[token.category] } as React.CSSProperties}
            >
               {token.label}
            </span>
         ))}
      </div>
   )
}

export default PartOfSpeechChips
